import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download } from "lucide-react";
import BulletinsHistoryChart from "@/components/BulletinsHistoryChart";

const MONTHS = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];

export default function SalariePaie() {
  const [items, setItems] = useState([]);
  const [history, setHistory] = useState([]);

  const load = async () => {
    try {
      const [list, hist] = await Promise.all([
        api.get("/salarie/bulletins"),
        api.get("/salarie/bulletins/history"),
      ]);
      setItems(list.data);
      setHistory(hist.data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const download = async (id, name) => {
    try {
      const res = await api.get(`/files/bulletin/${id}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name || "bulletin.pdf"; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Téléchargement impossible"); }
  };

  return (
    <div className="min-h-full">
      <PageHeader eyebrow="Paie" title="Mes bulletins de paie" sub="Téléchargez vos bulletins mensuels au format PDF." />
      <div className="p-6 lg:p-10 space-y-6">
        <BulletinsHistoryChart
          data={history}
          title="Mon historique 12 mois"
          subtitle="Cumul mensuel de vos bulletins de paie"
          testid="salarie-history-chart"
        />
        <div className="bg-white border border-[#DEE2E6]" data-testid="salarie-bulletins-list">
          <div className="grid grid-cols-12 gap-4 p-4 text-xs uppercase tracking-[0.2em] font-semibold bg-[#F8F9FA] border-b border-[#DEE2E6]">
            <div className="col-span-3">Période</div>
            <div className="col-span-4">Fichier</div>
            <div className="col-span-2">Brut</div>
            <div className="col-span-2">Reçu le</div>
            <div className="col-span-1 text-right"></div>
          </div>
          {items.length === 0 ? (
            <div className="p-8 text-center text-sm text-[#868E96]">Aucun bulletin disponible.</div>
          ) : items.map((b) => (
            <div key={b.id} className="grid grid-cols-12 gap-4 p-4 border-b border-[#DEE2E6] items-center text-sm" data-testid={`bulletin-${b.id}`}>
              <div className="col-span-3 font-display font-bold">{MONTHS[b.mois - 1]} {b.annee}</div>
              <div className="col-span-4 truncate text-[#495057]">{b.original_filename}</div>
              <div className="col-span-2 font-mono text-sm font-bold text-[#002FA7]">{b.brut != null ? `${Number(b.brut).toFixed(2)} €` : "—"}</div>
              <div className="col-span-2 font-mono text-xs">{new Date(b.uploaded_at).toLocaleDateString("fr-FR")}</div>
              <div className="col-span-1 text-right">
                <Button size="sm" variant="outline" onClick={() => download(b.id, b.original_filename)} data-testid={`download-bulletin-${b.id}`}><Download className="h-3 w-3" /></Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
